import { Box } from "@saleor/macaw-ui-next";
import React from "react";

type StepState = "completed" | "current" | "upcoming";

interface StepIconProps {
  icon: React.ComponentType<{ size?: number | string }>;
  state: StepState;
  size?: "small" | "large";
}

const stateStyles: Record<StepState, {
  bg: string;
  borderColor: string;
}> = {
  completed: {
    bg: "rgba(39, 174, 96, 0.12)",
    borderColor: "rgba(39, 174, 96, 0.3)",
  },
  current: {
    bg: "rgba(59, 130, 246, 0.12)",
    borderColor: "rgba(59, 130, 246, 0.3)",
  },
  upcoming: {
    bg: "rgba(148, 163, 184, 0.08)",
    borderColor: "rgba(148, 163, 184, 0.2)",
  },
};

export const StepIcon: React.FC<StepIconProps> = ({
  icon: Icon,
  state,
  size = "small",
}) => {
  const styles = stateStyles[state];
  const dimension = size === "large" ? "48px" : "32px";
  const iconSize = size === "large" ? 24 : 16;

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius={4}
      __width={dimension}
      __height={dimension}
      __backgroundColor={styles.bg}
      __flexShrink={0}
      style={{
        border: `1px solid ${styles.borderColor}`,
        transition: "all 0.2s ease",
      }}
    >
      <Icon size={iconSize} />
    </Box>
  );
};
